import styled from 'styled-components'

export const StyledButtonContainer = styled.ul`
    list-style: none;
    .ant-btn {
        display: flex;
        align-items: flex-end;
        flex-direction: column;
        justify-content: center;
        padding: 0;

        span {
            font-size: 2rem;
        }
    }
`
